export default __webpack_public_path__ + "static/tcofs-ew-wallpaper-3840x2160-920b6f2253cb8b4b7befff9fa1cbb2b0.jpg";